import React from 'react';
import { alignSingleBarLeft, hideBarPadLabel, isHiddenChartVariable, CHART_PALETTE_OP, CHART_TITLE_STYLE } from "../HelperFunction/helperFunction";
import Chart from 'react-apexcharts';
import { useOutletContext } from 'react-router-dom';

function SingleBarChart2op({optimizeddatasetmedia,type,isValue,range,maxValuedynamicVolume,maxValuedynamicValue,axisMax}) {
  const { theme } = useOutletContext();
  const isDark = theme !== 'light';
  let maxValue = isValue ? maxValuedynamicValue : maxValuedynamicVolume;
  let filtered_data = optimizeddatasetmedia?.filter(it => it.value_contribution > 0 && !isHiddenChartVariable(it))
  console.log(optimizeddatasetmedia)
  // Determine if the data contains 'frequency'
  const isStacked = filtered_data?.some(item => item?.frequency);
  if(isStacked){
    maxValue=3*maxValue
      }
  if (Number(axisMax) > 0) maxValue = Number(axisMax);
  let categories, series;

  if (isStacked) {
    // Extract unique frequencys and media variable types
    let uniqueFrequency = Array.from(new Set(filtered_data.map(item => item?.frequency)));
    let uniqueMediaTypes = Array.from(new Set(filtered_data.map(item => item?.variable_type)));

    // Group data by media variable type (stacked chart case)
    series = uniqueMediaTypes.map(mediaType => {
      return {
        name: mediaType,
        data: uniqueFrequency.map(frequency => {
          let dataPoint = filtered_data.find(item => item.variable_type === mediaType && item?.frequency === frequency);
          return dataPoint ? (isValue ? Number(dataPoint.contribution_sales_value / 100000).toFixed(2) : Number(dataPoint.value_contribution
          ).toFixed(0)) : 0;
        })
      };
    });
    categories = uniqueFrequency;
  } else {
    // Extract unique media variable types (non-stacked case)
    let uniqueMediaTypes = Array.from(new Set(filtered_data.map(item => item?.variable_type)));
    
    // Group data normally
    series = [{
      name: "Contribution",
      data: uniqueMediaTypes.map(mediaType => {
        let dataPoint = filtered_data.find(item => item.variable_type === mediaType);
        return dataPoint ? (isValue ? Number(dataPoint.contribution_sales_value / 100000).toFixed(2) : Number(dataPoint.value_contribution
        ).toFixed(0)) : 0;
      })
    }];
    categories = uniqueMediaTypes;
  }

  ({ categories, series } = alignSingleBarLeft(categories, series));
  const barColumnWidth = `${Math.min(70, Math.max(categories?.length || 1, 1) * 11)}%`;

  const options = {
    chart: {
      id: `Download-Contribution Chart for Media Variables`,
      type: 'bar',
      stacked: isStacked,
      toolbar: {
        show: true,
      },
      background: 'transparent',
    },
    grid: {
      show: false
    },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
    },
    title: {
      text: `Contribution ${isValue ? "Value" : "Volume"} for Media Variables (${type})`,
      align: 'center',
      style: CHART_TITLE_STYLE,
    },
    colors: CHART_PALETTE_OP,
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: barColumnWidth,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: isStacked?false:true,
      offsetY: -15,
      style: {
        fontSize: '12px',
        fontWeight: 600,      },
      formatter: function (val) {
        return (val?.toLocaleString("en-IN"));
      },
    },
    xaxis: {
      categories: categories,
      title: {
        text: '',
        style: {
          fontWeight: 600,
          fontSize: "12px",        },
      },
      labels: {
        rotate: -35,
        rotateAlways: true,
        formatter: (val) => hideBarPadLabel(val),
        style: {
          fontWeight: 500,
          fontSize: "11px",        },
      },
    },
    yaxis: {
      axisBorder: {
        show: true
      },
      min: 0,
      max: Math.ceil(maxValue),
      labels: {
        style: {
          fontWeight: 500,
          fontSize: "11px",        },
        formatter: function (val) {
          return val?.toFixed(0);
        },
      },
    },
    legend: {
      show: isStacked,
    },
    annotations: {
      yaxis: [{
        y: 0,
        borderColor: '#939598',
        label: {
          text: '',
          style: {
            color: '#939598',
            background: '#000'
          }
        }
      }]
    },
  };

  return (
    <>
      <div className="rr-chart-period">
        <small>Time Period: {range}</small>
      </div>
      <div className="rr-chart-yaxis">
        <span className="rr-chart-yaxis-label">
          {`Contribution ${isValue ? "Value (Lacs)" : "Volume (Kgs)"}`}
        </span>
        <div className="rr-chart-yaxis-body">
          <Chart className="rr-apex rr-apex-bar"
            align="center"
            options={options}
            series={series}
            type="bar"
            height={320}
            width={'100%'}
          />
        </div>
      </div>
    </>
  );
}

export default SingleBarChart2op;
